import { Dispatch } from 'react';
import { toast } from 'react-toastify';
import { IExtratoCartaoDto } from '../../../../global/dataTransferObjects/cartaoAgilitas/extratoCartao';
import { IPagedResult } from '../../../../global/generics';
import createContaVirtualService from '../../../../services/contaDigital';
import { IFilterExtratoCartao } from '../components/filterForm/types';
import { ActionTypes } from './types';

export const onUpdateLoadingStatus = (status = false) => (dispatch: Dispatch<any>): void => dispatch({
  type: ActionTypes.UPDATE_LOADING_STATUS,
  payload: {
    status,
  },
});

export const onUpdateTransacoes = (transacoes : IPagedResult<IExtratoCartaoDto>) => (dispatch: Dispatch<any>)
: void => dispatch({
  type: ActionTypes.UPDATE_TRANSACOES,
  payload: {
    transacoes: { ...transacoes },
  },
});

export const getTransacoes = (
  offset: number,
  pageSize : number,
  filter? : IFilterExtratoCartao,
) => async (dispatch: Dispatch<any>) : Promise<void> => {
  const contaDigitalService = createContaVirtualService();
  onUpdateLoadingStatus(true)(dispatch);
  const result = await contaDigitalService.getTransacoesCartao(offset, pageSize, filter);

  if (result.status !== 200) {
    toast.error(result.message);
  }

  onUpdateTransacoes(result.response)(dispatch);
}
